import React, { FC } from 'react';
import FeeAmountLoading from '../fee-amount-loading';
import type { FeeQuote } from '../../utils/fee';

interface FeeFooterRowProps {
  feeEstimate: FeeQuote | null
  feeLoading: boolean
  hasMedicareCard: boolean
  onOpenDetails: () => void
}

const money = (amount: number) => `$${amount.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** The estimated fee in the sticky footer; tapping it opens the fee summary. */
const FeeFooterRow: FC<FeeFooterRowProps> = ({
  feeEstimate,
  feeLoading,
  hasMedicareCard,
  onOpenDetails,
}) => {
  if (feeEstimate) {
    return (
      <button
        type="button"
        className="adhd-fee-row"
        onClick={onOpenDetails}
      >
        <span>
          <b>Estimated fee</b>
          <small>{hasMedicareCard ? 'Private fee · no Medicare rebate' : 'Private fee'}</small>
        </span>
        <span>
          <span className="adhd-fee-row__amount">{money(feeEstimate.gross)}</span>
          <em className="adhd-fee-row__details">Details ⌃</em>
        </span>
      </button>
    );
  }
  if (!feeLoading) return null;
  return (
    <div className="adhd-fee-row">
      <span>
        <b>Estimated fee</b>
        <small>Loading fee…</small>
      </span>
      <span>
        <span className="adhd-fee-row__amount"><FeeAmountLoading /></span>
      </span>
    </div>
  );
};

export default FeeFooterRow;
